<forge-card telemetry="Card-PacketProgress-UtilityBilling" class="chart" no-padding>
  <forge-toolbar>
    <div slot="start" fxLayout="column">
      <h2 class="forge-typography--heading4">Packet Progress</h2>
    </div>
  </forge-toolbar>

  <div class="metadata-padding">
    <div fxLayoutAlign="space-between stretch">
      @if (!isLoaded) {
        <busy-indicator [chart]="true"></busy-indicator>
      }

      @if(hasData) {
        <div fxLayout="row" fxLayoutAlign="space-between" class="content">

          @for (item of items; track item.Index; let i = $index;) {
            <div fxFlex="50" class="chart">
              @if (i > 1) {
                <forge-divider class="tt-margin--bottom"></forge-divider>
              }

              <packet-progress-chart [item]="item"></packet-progress-chart>
            </div>
          }
        </div>
      }
    </div>

    <div [fxShow]="isLoaded && !hasData" fxLayoutAlign="center start" class="footer">
      There are no packets in progress
    </div>
  </div>
</forge-card>